<template>
  <v-container v-if="items !== null" grid-list-xl ref="containerb" id="containerb">
    <br />
    <v-layout row wrap>
      <v-flex xs12>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-card-title>Administración de fuentes de financiamiento</v-card-title>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="buscafuente"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text active-class="deep-purple accent-4 white--text">
            <v-flex xs12 sm12>
              <v-data-table
                :headers="headerfuentes"
                :items="items"
                class="elevation-1"
                :no-data-text="gnodata"
                :no-results-text="gnosearch"
                :items-per-page="10"
                :search="buscafuente"
              >
                <template v-slot:top>
                  <v-toolbar>
                    <v-toolbar-title>Lista de fuentes</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-large
                          v-on="on"
                          @click="newpersona"
                          v-scroll-to="'#containera'"
                        >
                          <v-icon color="primary">add</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar</span>
                    </v-tooltip>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          small
                          class="mr-2"
                          @click="grideditfuente(item)"
                          v-scroll-to="'#containera'"
                        >edit</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          small
                          class="mr-2"
                          v-show="item.eliminar"
                          @click="eliminarfuente(item)"
                        >mdi-delete</v-icon>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </td>
                </template>
                <template v-slot:footer>
                  <div id="div1" style="width:100%;align:right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width:100%;text-align: right;"
                          v-show="items.length>0"
                          class="btn btn-default"
                          :data="items"
                          :exportFields="exportable"
                          name="Fuentes.xls"
                          type="xls"
                          worksheet="Información"
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                          >mdi-file-download-outline</v-icon>
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              
              <v-divider></v-divider>
            </v-flex>
          </v-card-text>

          <v-card v-show="framefuente" id="containera" ref="containera">
            <v-card-text>
              <v-flex row wrap>
                <v-flex sm12 xs12>
                  <v-text-field
                    v-model="fuente.nombre"
                    label="Nombre: *"
                    v-validate="'required|max:200'"
                    :counter="200"
                    data-vv-name="nombrefuncionario"
                    :error-messages="errors.collect('nombrefuncionario')"
                  ></v-text-field>
                </v-flex>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <br />
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mx-1"
                    v-on="on"
                    color="blue darken-1"
                    @click="cerrarrollocal"
                    v-scroll-to="'#containerb'"
                  >
                    <div class="text-white">Cancelar</div>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mx-1" v-on="on" color="blue darken-1" @click="preventguardar">
                    <div class="text-white">Guardar</div>
                  </v-btn>
                </template>
                <span>Guardar</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Confirmar eliminación</v-card-title>

        <v-card-text>
          <br />
          Se procederá a realizar la eliminación definitiva de la fuente de financiamiento: {{fuente.nombre}}, ¿confirma la ejecución de esta operación?.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="eliminarexistente">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack" :timeout="timeoutsnak" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert">{{buttontext}}</v-btn>
      <v-btn text v-show="snackalert" @click="cancelsave">Cancelar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "adminfuentes",
  data() {
    return {
      //Datos de las personas
      items: [],
      dialog: false,
      buscafuente: "",
      fuente: {},
      framefuente: false,
      editarfuente: false,
      editedpersonaIndex: -1,
      headerfuentes: [
        {
          text: "Nombre",
          value: "nombre",
          align: "left"
        },
        { text: "Acción", value: "action", sortable: false, width: 180 }
      ],

      exportable: {
        ID: "idfuente",
        Nombre: "nombre",
        Creación: "fechacreacion",
        Modificación: "fechamodificacion",
        Usuario: "usuariomodificacion"
      },

      //plantillas footer data-tables rol


      //elementos del fomrulario
      buttonguardarestado: false,
      buttonfinalizarestado: false,
      loading: false,

      //campos del cuadro de dialog de mensajes
      snack: false,
      snackalert: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "cerrar",

      //Validacion de campos
      dictionary: {
        custom: {
          nombrefuncionario: {
            required: () => "El nombre de la fuente es obligatorio",
            alpha_spaces: "Los valores ingresados",
            max: "Está superando el límite de caracteres"
          }
        }
      }
    };
  },
  methods: {
    ...mapActions([
      "get_fuentes",
      "post_fuente",
      "put_fuente",
      "delete_fuente"
    ]),
    salvarexistente() {
      this.loading = true;
      this.put_fuente({
        data: this.fuente
      });
    },
    salvarnuevo() {
      this.loading = true;
      this.post_fuente({
        data: this.fuente
      });
    },
    eliminarexistente() {
      this.loading = true;
      this.delete_fuente({
        params: { idfuente: this.fuente.idfuente }
      });
    },
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "cerrar";
      this.timeoutsnak = 4000;
    },
    preventguardar() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          ///este console lo vamos a dejar para ver los posibles error de validación
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach(element => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          if (this.editarfuente === false) {
            this.salvarnuevo();
          } else {
            this.salvarexistente();
          }
        }
      });
    },
    cerrarrollocal() {
      this.framefuente = false;
      this.editarfuente = false;

      this.Editedpersona = [];
      this.EditedUsuario = [];
    },
    grideditfuente(item) {
      this.framefuente = true;
      this.editarfuente = true;
      this.fuente = Object.assign({}, item);
    },
    newpersona() {
      this.editarfuente = false;
      this.framefuente = true;
      this.fuente = {
        nombre: "",
        idfuente: 0
      };
    },
    eliminarfuente(item) {
      this.dialog = true;
      this.fuente = Object.assign({}, item);
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.snack = false;
        this.snackalert = false;
        this.timeoutsnak = 4000;
        this.buttontext == "cerrar";
        this.guardarrollocal();
      }
    }
  },
  created() {
    this.get_fuentes();      
  },
  $_veeValidate: {
    validator: "new"
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  computed: {
    ...mapGetters([
      "gpersonas",
      "gentidades",
      "groles",
      "gtipodocumentos",
      "gfuentes"
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "gnosearch"]),
    itemsporpagina() {
      if (!isNaN(this.itemsPerPageSopCuan)) return this.itemsPerPageSopCuan;
      else return 1;
    }
  },
  watch: {
    gfuentes: function() {
      this.items = this.gfuentes;
    },
    ginformation() {
      if (this.loading) {
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        this.loading = false;
        if (this.MesaggeInfo.codigoRespuesta === "") {
          this.framefuente = false;
          this.dialog = false;
          setTimeout(() => {
            this.get_fuentes();
          }, 2000);
        }
      }
    }
  }
};
</script>